const ImportBatches = () => (
    <div className="page-content">
        <h1>Lots d'import</h1>
        <p>Bienvenue sur la page Lots d'import.</p>
    </div>
);

export default ImportBatches;